module.exports = __webpack_public_path__ + "static/media/Gwen-profile.385bd406.jpg";